
import Badge from 'vux/src/components/badge/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

export default {
name: "",
props: [""],
data() {
return {};
},

components: { Badge, Group, Cell },

created() {},

beforeMount() {},

mounted() {},
methods: {},

watch: {}
};



// WEBPACK FOOTER //
// ./src/components/about.vue